import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { HallService } from '@services/hall.service';
import { SeoService } from '@services/seo.service';
import { Router, ActivatedRoute } from '@angular/router';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { infoBoxComponent } from '@components/info-box/info-box.component';

const WEEKDAYS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

@Component({
	selector: 'app-hall-detail',
	templateUrl: './hall-detail.component.html',
	styleUrls: ['./hall-detail.component.scss']
})
export class HallDetailComponent implements OnInit {
	private sub: any;
	hall: any;
	hallId: string;
	hallSlug: string;
	id;
	map = {
		options: {
		  streetViewControl: false,
		  panControl: false,
		  maxZoom: 20,
		  minZoom: 2,
		  zoom: 18,
		  scrollwheel: false,
		  zoomControl: true,
		  styles: [{"stylers":[{"saturation":-100},{"gamma":1}]},{"elementType":"labels.text.stroke","stylers":[{"visibility":"off"}]},{"featureType":"poi.business","elementType":"labels.text","stylers":[{"visibility":"off"}]},{"featureType":"poi.business","elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"poi.place_of_worship","elementType":"labels.text","stylers":[{"visibility":"off"}]},{"featureType":"poi.place_of_worship","elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"road","elementType":"geometry","stylers":[{"visibility":"simplified"}]},{"featureType":"water","stylers":[{"visibility":"on"},{"saturation":50},{"gamma":0},{"hue":"#50a5d1"}]},{"featureType":"administrative.neighborhood","elementType":"labels.text.fill","stylers":[{"color":"#333333"}]},{"featureType":"road.local","elementType":"labels.text","stylers":[{"weight":0.5},{"color":"#333333"}]},{"featureType":"transit.station","elementType":"labels.icon","stylers":[{"gamma":1},{"saturation":50}]}]
		}
	  };
	latitude: number;
	longitude: number;
	icon = {
		url: "../../../assets/Spielo-Mapmarker.png",
	}
	googleMapsUrl: string = 'https://www.google.com/maps/search/?api=1&query=';
	schema;
	kind;
	isBrowser: boolean;
	constructor(
		private route: ActivatedRoute,
		private router: Router,
		private hallService: HallService,
		private dialog: MatDialog,
		private seoService: SeoService,
		@Inject(PLATFORM_ID) private platformId: Object,
	) {
		this.isBrowser = isPlatformBrowser(this.platformId);
	}

    ngOnInit() {
		this.hallSlug = this.route.snapshot.params['slug'];
		console.log(this.hallSlug)
		this.hallService.getHallBySlug(this.hallSlug).subscribe(res => {
			console.log(res)
			this.hall = res;
			this.hallId = res["_id"];
			console.log(this.hall)
			 this.latitude = res["location"].coordinates[1]
			 this.longitude = res["location"].coordinates[0]

			 const canonicalPath = '/' + this.hall.kind + '/' + this.hall.slug;

			 this.schema = {
                "@context": "https://schema.org",
                "@type": "CasinoOrGamblingEstablishment",
                "url": 'https://spieloguide.de' + canonicalPath,
                "name": this.hall.name,
                "address": {
                  "@type": "PostalAddress",
                  "addressLocality": this.hall.cityname,
				  "addressRegion": this.hall.state,
				  "postalCode": this.hall.plz,
                  "streetAddress":  this.hall.streetNr,
                  "addressCountry": "DE"
                },
                "geo": {
                  "@type": "GeoCoordinates",
                  "latitude": this.latitude,
                  "longitude": this.longitude
                },
                "openingHoursSpecification": this.buildOpeningHoursSpecification(this.hall.openinghours && this.hall.openinghours.normaldays)
			  };

			  // Meta Title kind
			  if(this.hall.kind == "spielhalle") {
				this.kind = "Spielhalle";
			  } else if (this.hall.kind == "wettbuero") {
				this.kind = "Wettbüro";
			  } else if (this.hall.kind == "automaten") {
				this.kind = "Automaten";
			  }

			  // set Meta title/description/canonical/OG
			  const title = this.kind + " - " + this.hall.name + " - " + this.hall.streetNr + " - " + this.hall.plz + " - " +  this.hall.cityname;
			  this.seoService.set({
				title: title,
				description: title,
				path: canonicalPath
			  });
		  });

        // this.sub = this.route.params.subscribe(params => {
        //     this.hallSlug = params['slug'];
        // });

        // this.hallService.getHallBySlug(this.id).subscribe(data => {
		// 	this.hall = data;
		// 	console.log(this.hall)
		// });
	};

	private buildOpeningHoursSpecification(normaldays: any): any[] {
		if (!normaldays) {
			return [];
		}
		const specification = [];
		Object.keys(normaldays).forEach(dayIndex => {
			const slots = normaldays[dayIndex];
			if (!Array.isArray(slots)) {
				return;
			}
			slots.forEach(slot => {
				if (!slot || !slot.start || !slot.end) {
					return;
				}
				specification.push({
					"@type": "OpeningHoursSpecification",
					"dayOfWeek": "https://schema.org/" + WEEKDAYS[Number(dayIndex)],
					"opens": slot.start,
					"closes": slot.end
				});
			});
		});
		return specification;
	}

	openInfoBox(position): void {
        console.log("position");
        const dialogRef = this.dialog.open(infoBoxComponent, {
            width: '500px',
            data: {
                position: position,
            }
        });
    };
	
	startNavigation(coords) {
			// open url in new browser tab
			let url = this.googleMapsUrl + String(coords[1]) + ',' +  String(coords[0]);
			window.open(url, '_blank');
	}
}
